"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
const _excluded = ["fill"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconLogic = _ref => {
  let {
      fill
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    label: "Logic"
  }, others), /*#__PURE__*/_react.default.createElement("g", {
    id: "Icon/logic"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: fill,
    d: "M4.5 0C5.88071 0 7 1.11929 7 2.5C7 3.6649 6.20327 4.64371 5.125 4.92124V6.875H9.07876C9.35629 5.79673 10.3351 5 11.5 5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10C10.3351 10 9.35629 9.20327 9.07876 8.125H5.125V12.875H9.07876C9.35629 11.7967 10.3351 11 11.5 11C12.8807 11 14 12.1193 14 13.5C14 14.8807 12.8807 16 11.5 16C10.3351 16 9.35629 15.2033 9.07876 14.125H5.125H3.875V12.875V8.125V6.875V4.92124C2.79673 4.64371 2 3.6649 2 2.5C2 1.11929 3.11929 0 4.5 0ZM4.5 1.5C3.94772 1.5 3.5 1.94772 3.5 2.5C3.5 3.05228 3.94772 3.5 4.5 3.5C5.05228 3.5 5.5 3.05228 5.5 2.5C5.5 1.94772 5.05228 1.5 4.5 1.5ZM11.5 12.5C10.9477 12.5 10.5 12.9477 10.5 13.5C10.5 14.0523 10.9477 14.5 11.5 14.5C12.0523 14.5 12.5 14.0523 12.5 13.5C12.5 12.9477 12.0523 12.5 11.5 12.5ZM10.5 7.5C10.5 6.94772 10.9477 6.5 11.5 6.5C12.0523 6.5 12.5 6.94772 12.5 7.5C12.5 8.05228 12.0523 8.5 11.5 8.5C10.9477 8.5 10.5 8.05228 10.5 7.5Z"
  })));
};
IconLogic.defaultProps = {
  fill: 'black'
};
IconLogic.propTypes = Object.assign({}, _Icon.propTypes, {
  fill: _propTypes.default.string
});
var _default = exports.default = IconLogic;